import React, { useContext, useEffect, useRef, useState } from "react";
import { animated, useSpring } from "@react-spring/three";
import { useGLTF } from "@react-three/drei";
import CurrentContext from "./CurrentContext";
import useSetMaterialFinish from "./useTextureCustom";
import { handleExportGLTF } from "./utils/jsHelpers";
import { useControls } from "leva";
import { Deg0, Deg90CCW } from "./utils/AnimaonSprings";

export default function Model_guemes() {
  const { nodes, materials, scene } = useGLTF("models/guemes.glb");
  const [finishes, setFinishes] = useState({});
  const [tileFinishes, setTileFinishes] = useState({});

  const {
    grill,
    setGrill,
    siding,
    setSiding,
    door,
    setDoor,
    secondDoor,
    colorScheme,
    setcolorScheme,
    loading,
    setLoading,
    isARReady,
    setIsARReady,
    ARModelSrc,
    setARModelSrc,
    ARUnicode,
    setARUnicode,
    isAR,
    setIsAR,
    umbrellHole,
    setUmbrellHole,
    bottleOpener,
    setBottleOpener,
    sideBurner,
    refrigerator,
    refrigeratorType,
    setRefrigeratorType,
    animation,
    tileColorScheme,
    setTileColorScheme,
    sink,
    groutColor,
    setGroutColor,
  } = useContext(CurrentContext);

  useEffect(() => {
    if (siding === "Quartzite") {
      if (colorScheme === "Sandstone Tan SR12") {
        setFinishes({
          diffuseMap: "../textures/big/quartzite-sandstone-tan.jpg",
          displacementMap: null,
          normalMap: "../textures/big/normal_quartzite-sandstone-tan.jpg",
          normalScale: [0.3, 0.3],
          repeat: [8, 8],
        });
      }
      if (colorScheme === "Misty Gray SR16") {
        setFinishes({
          diffuseMap: "../textures/big/quartzite-misty-gray.jpg",
          displacementMap: null,
          normalMap: "../textures/big/normal_quartzite-misty-gray.jpg",
          normalScale: [0.3, 0.3],
          repeat: [8, 8],
        });
      }
    } else if (siding === "Faux Rock") {
      if (colorScheme === "Gray") {
        setFinishes({
          diffuseMap: "../textures/big/fauxrock-gray.jpg",
          aoMap: "../textures/big/bbq_faux_brick_ao.jpg",
          normalMap: "../textures/big/faux_brick_normal.png",
          normalScale: [1, 1],
        });
      }
      if (colorScheme === "Brown") {
        setFinishes({
          diffuseMap: "../textures/big/fauxrock-brown.jpg",
          aoMap: "../textures/big/bbq_faux_brick_ao.jpg",
          normalMap: "../textures/big/faux_brick_normal.png",
          normalScale: [1, 1],
        });
      }
    } else if (siding === "No Siding") {
      setFinishes({
        diffuseMap: "../textures/big/no-siding-1k.jpeg",
        displacementMap: null,
        // normalMap: "../textures/big/normal_quartzite-misty-gray.jpg",
        normalScale: [1, 1],
        repeat: [5, 5],
        // aoMap1: refrigerator ? '../textures/big/san_jaun_qurtize_base_with_fridge_ao.jpg' : '../textures/big/san_jaun_qurtize_base_without_fridge_ao.jpg'
      });
    }
    {
      if (tileColorScheme === "Chocolate") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-chocolate.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#928272",
        });
      }
      if (tileColorScheme === "Civic Sand") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-civic-sand.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#e5e3dec7",
        });
      }
      if (tileColorScheme === "Notable beige") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-notable-beige.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#eeebe5",
        });
      }
      if (tileColorScheme === "Park Lane Gray") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-park-lane-gray.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#c6ccd4",
        });
      }
      if (tileColorScheme === "Union smoke") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-union-smoke.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#8c95a2",
        });
      }
      if (tileColorScheme === "Iron Gray") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-iron-gray.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#818084",
        });
      }
      if (tileColorScheme === "No Tile") {
        setTileFinishes({
          diffuseMap: "../textures/big/no-siding-1k.jpeg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
          // aoMap1: '../textures/big/san_jaun_top_AO.jpg',
        });
        setGroutColor({
          color: "#818084",
        });
      }
    }
  }, [siding, colorScheme, tileColorScheme]);

  useSetMaterialFinish(materials.siding, finishes, setLoading);
  useSetMaterialFinish(
    materials.countertop_with_sink_frame,
    groutColor,
    setLoading
  );
  useSetMaterialFinish(materials.island_top, tileFinishes, setLoading);

  const { rotation_Grill } = useSpring({
    rotation_Grill: animation ? Deg90CCW : Deg0,
    config: { duration: 1000 },
    delay: animation ? 500 : 0,
  });

  const { rotation_Side_burner } = useSpring({
    rotation_Side_burner: animation ? Deg90CCW : Deg0,
    config: { duration: 1000 },
    delay: animation ? 0 : 500,
  });

  return (
    <group dispose={null}>
      {/* brahma starts here */}
      {/* {grill === '38" Brahma' ? (
        <> */}
      {/* bottle_opener_1 */}
      {siding !== "Faux Rock" && bottleOpener && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-92_bottle_opener"].geometry}
            material={materials["Brahma-bottle_opener"]}
            // visible={siding === "Quartzite" && bottleOpener ? true : false}
            position={[-0.002, 0, 0]}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes["Brahma-bottle_opener_logo"].geometry}
              material={materials["Brahma-bottle_opener_logo"]}
              position={[0.002, 0, 0]}
            />
          </mesh>
        </>
      )}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['Brahma-15"_sink'].geometry}
        material={materials['Brahma-15"_sink']}
        visible={sink === true ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['Brahma-38"_brahma'].geometry}
        material={materials['Brahma-38"_brahma']}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Brahma-38"_brahma_alpha'].geometry}
          material={materials['Brahma-38"_brahma_alpha']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Brahma-38"_brahma_front_part'].geometry}
          material={materials['Brahma-38"_brahma_front_part']}
        />
        <animated.group
          position={[-0.247, 1.108, 0.03]}
          rotation={rotation_Grill}
        >
          <animated.mesh
            castShadow
            receiveShadow
            geometry={nodes['Brahma-38"_brahma_top'].geometry}
            material={materials['Brahma-38"_brahma_top']}
            // position={[-0.247, 1.108, 0.03]}
          >
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes['Brahma-38"_brahma_glass'].geometry}
              material={materials['Brahma-38"_brahma_glass']}
              position={[-0.441, 0.13, 0.249]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes['Brahma-38"_brahma_temperature'].geometry}
              material={materials['Brahma-38"_brahma_temperature']}
              position={[-0.441, 0.119, 0.242]}
            />
          </animated.mesh>
        </animated.group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Brahma-38"_brahma_metal'].geometry}
          material={materials['Brahma-38"_brahma_metal']}
        />
      </mesh>
      {/* Brahma-38"_double_door */}
      <group
        visible={door === '38" Double Door' ? true : false}
        position={[-0.003, -0.003, 0]}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Brahma-38"_double_door_1'].geometry}
          material={materials['Brahma-38"_double_door']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Brahma-38"_double_door_2'].geometry}
          material={materials['Brahma-38"_double_door_back_part']}
        />
      </group>
      {tileColorScheme === "No Tile" && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.metal_top_with_sink.geometry}
            material={materials.island_top}
            visible={sink === true ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.metal_top.geometry}
            material={materials.island_top}
            visible={sink === true ? false : true}
          />
        </>
      )}
      {!(tileColorScheme === "No Tile") && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-countertop_with_sink_base"].geometry}
            material={materials.island_top}
            visible={sink === true ? true : false}
          />

          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-countertop_with_sink_frame"].geometry}
            material={materials.countertop_with_sink_frame}
            visible={sink === true ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-countertop_without_sink_frame"].geometry}
            material={materials.countertop_with_sink_frame}
            visible={sink === true ? false : true}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-countertop_without_sink_base"].geometry}
            material={materials.island_top}
            visible={sink === true ? false : true}
          ></mesh>
        </>
      )}
      {/* <mesh
          castShadow
          receiveShadow
          geometry={nodes["Brahma-countertop_without_sink_frame"].geometry}
          material={materials["Brahma-countertop_without_sink_frame"]}
        /> */}

      {/* <mesh
              castShadow
              receiveShadow
              geometry={nodes["Brahma-countertop_with_sink_top"].geometry}
              material={materials.island_top}
            /> */}
      {/* </mesh> */}
      {/* <mesh
        castShadow
        receiveShadow
        geometry={nodes["Brahma-countertop_without_sink_base"].geometry}
        material={materials.island_top}
        visible={sink === true ? false : true}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["Brahma-countertop_without_sink_frame"].geometry}
          material={materials["Brahma-countertop_without_sink_frame"]}
        />
      </mesh> */}
      {/* 30" Double Door */}
      {/* <mesh
            castShadow
            receiveShadow
            geometry={nodes['Brahma-door-30"_double_door'].geometry}
            material={materials['Brahma-door-30"_double_door']}
            visible={door === '30" Double Door' ? true : false}
          /> */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['Brahma-door-30"_double_door_1'].geometry}
        material={materials['Brahma-door-30"_double_door']}
        visible={door === '30" Double Door' ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['Brahma-door-30"_double_door_2'].geometry}
        material={materials['Brahma-door-30"_double_door_back_part']}
        visible={door === '30" Double Door' ? true : false}
      />
      {/* 30" Door/Drawer Combo */}
      {/* <mesh
            castShadow
            receiveShadow
            geometry={
              nodes['Brahma-door-30"_double_drawer_door_combo'].geometry
            }
            material={materials['Brahma-door-30"_double_drawer_door_combo']}
            visible={door === '30" Door/Drawer Combo' ? true : false}
          /> */}
      {door === '30" Door/Drawer Combo' && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-door-double_drawer_door_combo"].geometry}
            material={materials['Brahma-door-30"_double_drawer_door_combo']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-double_drawer_door_combo_handle"].geometry}
            material={materials["Brahma-double_drawer_door_combo_handle"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-door-double_drawer_door_combo_1"].geometry}
            material={
              materials['Brahma-door-30"_double_drawer_door_combo_back_part']
            }
          />
        </>
      )}
      {tileColorScheme === "No Tile" && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.metal_side.geometry}
            material={materials.metal_side}
          />
        </>
      )}
      {/* 30" Door/Propane Drawer Combo */}
      {door === '30" Door/Propane Drawer Combo' && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-door-door_propane_drawer_combo_1"].geometry}
            material={materials["Brahma-door-door_propane_drawer_combo"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-door-door_propane_drawer_combo_2"].geometry}
            material={
              materials["Brahma-door-door_propane_drawer_combo_back_part"]
            }
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-door_propane_drawer_combo_handle"].geometry}
            material={materials["Brahma-door_propane_drawer_combo_handle"]}
          />
        </>
      )}
      {refrigeratorType !== "None" && (
        <>
          <group
            position={[0.007, 0, 0]}
            visible={refrigeratorType === "Standard Fridge" ? true : false}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes["Brahma-refrigerator_1"].geometry}
              material={materials["Brahma-refrigerator"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes["Brahma-refrigerator_2"].geometry}
              material={materials["Brahma-refrigerator_frame"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes["Brahma-refrigerator_3"].geometry}
              material={materials["Brahma-door_propane_drawer_combo_handle"]}
            />
          </group>

          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-outdoor_rated_fridge_1"].geometry}
            material={materials["Brahma-outdoor_rated_fridge"]}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-outdoor_rated_fridge_2"].geometry}
            material={materials["Brahma-outdoor_rated_fridge_2"]}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-outdoor_rated_fridge_3"].geometry}
            material={materials["Brahma-outdoor_rated_fridge_frame"]}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-outdoor_rated_fridge_4"].geometry}
            material={materials['Brahma-38"_brahma_top']}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-outdoor_rated_fridge_5"].geometry}
            material={materials["Brahma-door_propane_drawer_combo_handle"]}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
        </>
      )}

      {siding === "Faux Rock" ? (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-plug_1"].geometry}
            material={materials["Brahma-plug_1"]}
            position={[0.02, 0, 0]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-net_1_89"].geometry}
            material={materials["Brahma-net_1"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-net_2_89"].geometry}
            material={materials["Brahma-net_2"]}
          />
          {refrigeratorType !== "None" ? (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes["Brahma-side_89_with_sink_30_door"].geometry}
                material={materials.siding}
                position={[-0.001, 0, 0]}
                scale={[0.959, 1, 1]}
              />
            </>
          ) : (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes["Brahma-side_89_without_fridge"].geometry}
                material={materials.siding}
                scale={[0.959, 1, 1]}
              />
            </>
          )}

          <mesh
            castShadow
            receiveShadow
            geometry={nodes['Brahma-89"_skirting'].geometry}
            // material={materials['Brahma-89"_skirting']}
            material={materials.siding}
          />
        </>
      ) : (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-plug_1"].geometry}
            material={materials["Brahma-plug_1"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-net_1"].geometry}
            material={materials["Brahma-net_1"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-net_2"].geometry}
            material={materials["Brahma-net_2"]}
          />
          {refrigeratorType !== "None" ? (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes["Brahma-side_92_with_fridge"].geometry}
                material={materials.siding}
                position={[-0.001, 0, 0]}
                // scale={[0.959, 1, 1]}
              />
              {/* <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes['Brahma-side_92_with_fridge'].geometry}
                        material={materials.siding}
                    /> */}
            </>
          ) : (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes["Brahma-side_92_without_fridge"].geometry}
                material={materials.siding}
                // position={[-0.186, 0.473, -0.002]}
              />
            </>
          )}

          <mesh
            castShadow
            receiveShadow
            geometry={nodes['Brahma-92"_skirting'].geometry}
            // material={materials['Brahma-89"_skirting']}
            material={materials.siding}
            position={[-0.186, 0.02, 0]}
          />
        </>
      )}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["Brahma-side_burner_base"].geometry}
        material={materials["Brahma-side_burner_base"]}
        visible={sideBurner ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["Brahma-side_burner_knob_logo"].geometry}
          material={materials["Brahma-side_burner_knob_logo"]}
        />
        <animated.group
          position={[0.144, 1.002, -0.197]}
          rotation={rotation_Side_burner}
        >
          <animated.mesh
            castShadow
            receiveShadow
            geometry={nodes["Brahma-side_burner_top"].geometry}
            material={materials["Brahma-side_burner_top"]}
            // position={[0.144, 1.002, -0.197]}
          />
        </animated.group>
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["Brahma-umbrella_hole_1"].geometry}
        material={materials["Brahma-umbrella_hole"]}
        visible={umbrellHole ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["Brahma-umbrella_hole_2"].geometry}
        material={materials.hole}
        visible={umbrellHole ? true : false}
      />
      {/* 38" Door/Drawer Combo */}
      {door === '38" Door/Drawer Combo' && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes['Brahma-38"_doordrawer_1'].geometry}
            material={materials['Brahma-38"_door/drawer']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes['Brahma-38"_doordrawer_2'].geometry}
            material={materials['Brahma-38"_door/drawer_2']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes['Brahma-38"_doordrawer_3'].geometry}
            material={materials['Brahma-38"_door/drawer_2_back_part']}
          />
        </>
      )}
      {/* </>
      ) : null} */}
    </group>
  );
}
